/* Sniggles PDP behavior — variant pills, gallery, live services total, qty
   stepper, mobile sticky bar, and AJAX add-to-bag. Vanilla JS, no framework.
   Auto-inits every [data-sn-pdp] root; all copy comes from data-* attributes
   so this file carries no Liquid. See the cart integration contract in
   sections/sniggles-product.liquid. */
(function () {
  function initPdp(root) {
    if (!root || root.dataset.snPdpReady === '1') return;
    root.dataset.snPdpReady = '1';

    var currency = root.getAttribute('data-currency') || 'USD';
    var settings = {
      addLabel: root.getAttribute('data-add-label') || 'Add to bag',
      soldOut: root.getAttribute('data-soldout-label') || 'Sold out',
      error: root.getAttribute('data-error-label') || 'Something went wrong. Please try again.',
      productTitle: root.getAttribute('data-product-title') || ''
    };

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format((cents || 0) / 100);
      } catch (e) {
        return ((cents || 0) / 100).toFixed(2);
      }
    };

    var form = root.querySelector('[data-pdp-form]');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceBox = root.querySelector('[data-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var atb = root.querySelector('[data-add-to-bag]');
    var atbTotal = root.querySelector('[data-atb-total]');
    var atbLabel = root.querySelector('[data-atb-label]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var errorBox = root.querySelector('[data-atb-error]');
    var qtyInput = root.querySelector('[data-qty-input]');

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
    } catch (e) { variants = []; }

    // ----- Price rendering (matches .sn-price markup) -----
    function priceHTML(variant) {
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = '<span class="sn-price' + (sale ? ' sn-price--sale' : '') + '">';
      html += '<span class="sn-price__current">' + money(variant.price) + '</span>';
      if (sale) html += '<span class="sn-price__was">' + money(variant.compare_at_price) + '</span>';
      html += '</span>';
      return html;
    }

    // ----- Selected variant, from active pills -----
    function selectedValues() {
      return Array.prototype.map.call(
        root.querySelectorAll('.sn-pdp__opt'),
        function (opt) {
          var active = opt.querySelector('.sn-pdp__pill.is-active');
          return active ? active.getAttribute('data-option-value') : null;
        }
      );
    }

    function matchVariant(values) {
      if (!variants.length) return null;
      if (!values.length || values[0] === null) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (variants[i].options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function currentVariant() {
      return matchVariant(selectedValues()) || variants[0] || null;
    }

    // ----- Live total (base + checked services) -----
    function checkedServices() {
      return Array.prototype.filter.call(
        root.querySelectorAll('[data-service]'),
        function (el) { return el.checked; }
      );
    }

    function updateTotal() {
      var v = currentVariant();
      if (!v) return;
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var svcTotal = checkedServices().reduce(function (sum, el) {
        return sum + (parseInt(el.getAttribute('data-price'), 10) || 0);
      }, 0);
      var grand = v.price * qty + svcTotal;
      if (atbTotal) {
        atbTotal.textContent = svcTotal > 0 ? ' · ' + money(grand) : '';
      }
    }

    // ----- Gallery: scroll-snap stage + dots + thumbs -----
    var stage = root.querySelector('[data-gallery-stage]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    function goToSlide(index) {
      if (!stage) return;
      var slide = stage.children[index];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    // ----- Apply a variant selection -----
    function applyVariant() {
      var v = currentVariant();
      if (!v) return;
      variantInput.value = v.id;

      if (priceBox) priceBox.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v);

      var soldOut = !v.available;
      [atb, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = soldOut;
        btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      });
      if (atbLabel) atbLabel.textContent = soldOut ? settings.soldOut : settings.addLabel;
      if (stickyAdd) stickyAdd.textContent = soldOut ? settings.soldOut : settings.addLabel;

      if (v.media_id != null) {
        var slides = root.querySelectorAll('[data-slide]');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') == String(v.media_id)) {
            goToSlide(i);
            break;
          }
        }
      }
      updateTotal();
    }

    // ----- Pill clicks -----
    root.querySelectorAll('.sn-pdp__opt').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        var pill = e.target.closest('.sn-pdp__pill');
        if (!pill) return;
        opt.querySelectorAll('.sn-pdp__pill').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');
        applyVariant();
      });
    });

    // ----- Quantity stepper -----
    var qtyDec = root.querySelector('[data-qty-dec]');
    var qtyInc = root.querySelector('[data-qty-inc]');
    function clampQty() {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 99) val = 99;
      qtyInput.value = val;
      if (qtyDec) qtyDec.disabled = val <= 1;
      updateTotal();
    }
    if (qtyDec) qtyDec.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; clampQty(); });
    if (qtyInc) qtyInc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; clampQty(); });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    root.querySelectorAll('[data-service]').forEach(function (el) {
      el.addEventListener('change', updateTotal);
    });

    // ----- Gallery wiring -----
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goToSlide(parseInt(d.getAttribute('data-index'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(parseInt(t.getAttribute('data-index'), 10)); });
    });
    if (stage) {
      var scrollTimer;
      stage.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var idx = Math.round(stage.scrollLeft / stage.clientWidth);
          setActive(idx);
        }, 80);
      });
    }

    // ----- Mobile sticky bar: appears after the buy row scrolls out of view -----
    var sticky = root.querySelector('[data-sticky]');
    var buyrow = root.querySelector('.sn-pdp__buyrow');
    if (sticky && buyrow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(buyrow);
    }

    // ----- Add to bag (AJAX) — honors the cart integration contract -----
    function buildItems() {
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var items = [{ id: v.id, quantity: qty }];
      checkedServices().forEach(function (el) {
        items.push({
          id: parseInt(el.getAttribute('data-id'), 10),
          quantity: 1,
          properties: {
            _service_of: settings.productTitle,
            _parent_line: String(v.id)
          }
        });
      });
      return items;
    }

    function setBusy(state) {
      [atb, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        if (state) { btn.setAttribute('aria-busy', 'true'); }
        else { btn.removeAttribute('aria-busy'); }
      });
    }

    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available) return;
      if (errorBox) errorBox.textContent = '';
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          var items = data.items || (data.id ? [data] : []);
          document.dispatchEvent(new CustomEvent('sniggles:cart:added', { detail: { items: items } }));
          if (window.SnigglesCart && typeof window.SnigglesCart.open === 'function') {
            window.SnigglesCart.open();
          } else {
            fetch('/cart.js')
              .then(function () { window.location.href = '/cart'; })
              .catch(function () { window.location.href = '/cart'; });
          }
        })
        .catch(function (err) {
          if (errorBox) errorBox.textContent = (err && err.description) ? err.description : settings.error;
        })
        .finally(function () { setBusy(false); });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(); });

    // Init
    clampQty();
    applyVariant();
  }

  function boot() {
    document.querySelectorAll('[data-sn-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();
